import { Model, Factory, trait } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randPhrase, randChanceBoolean } from '@ngneat/falso'
import { filterable } from './utils.js'

import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'
import { toNumber } from '@/utils/number.js'

export type CancellationReasonData = SchemaAttributes<'CancellationReason'>

export const model = Model as ModelDefinition<CancellationReasonData>

export const factory = Factory.extend<CancellationReasonData>({
  name() {
    return randPhrase({ maxCharCount: 60 })
  },
  archived() {
    return randChanceBoolean({ chanceTrue: 0.1 })
  },
  withNotArchived: trait({
    archived: false,
  }),
  afterCreate(cancellationReason, server) {
    cancellationReason.update({
      department_id: toNumber(server.schema.first('department')?.id),
    })
  },
})

export function routes(server: MockServer) {
  server.resource('cancellationReason', { path: '/cancellation_reasons' })

  server.get('/cancellation_reasons', function (schema, request) {
    const reasons = schema.all('cancellationReason')

    return filterable(reasons, request, {
      department_id: (item, value) => item.department_id === Number(value),
      archived: (item, value) => item.archived === (value === 'true'),
    })
  })
}

export function seeds(server: MockServer) {
  server.createList('cancellationReason', 10)
}
